<template>
	<svg :class="computeClass">
		<use :xlink:href="`#icon--${icon}`"></use>
	</svg>
</template>

<script>
	export default {
		name: 'SvgIcon',
		props: {
            icon: {
                type: String,
                required: true,
            },
            isFilled: {
                type: Boolean,
                default: false,
            },
            classes: {
                type: String,
                default: ''
            },
		},
		computed: {
			computeClass(){
                const classes = ["svg-icon"];

                if(this.isFilled) {
                    classes.push("filled");
                }

                const classString = classes.join(" ");

				return `${classString} ${this.classes}`;
			}
		}
	}
</script>

<style lang="scss">
	@import '~reflex-grid/scss/includes/variables';
	@import '~reflex-grid/scss/includes/mixins';
	@import '~@/theme/_variables.scss';
	@import '~@/mixins/_class.scss';
	@import '~@/theme/_extenables.scss';

	.svg-icon {
		display: inline-block;
		width: 2.5rem;
		height: 2.5rem;
		max-height: 100%;
		max-width: 100%;
		opacity: 1;
		pointer-events: none;
		vertical-align: middle;
		stroke: $text;

        &.filled {
            use {
                stroke: none;
                fill: currentColor;
            }
        }

		svg {
			width: 100%;
			height: 100%;
		}

		use {
			max-width: 100%;
			height: auto;
			fill: none;
			stroke: currentColor;
		}
	}
</style>
